module.exports = __webpack_public_path__ + "images/feature/ical-sub-ed5090f746f07fbcd8d37d28d2f61bad.jpg";